import React from 'react';

import HomePage from '../components/HomePage/HomePage';


export default function Home() {
    return (
        <React.Fragment>
            <HomePage />
        </React.Fragment>
    )
}
